<template>
    <div>
        <el-form-item :label="field.name + '：'" label-width="110px">
            <image-uploader :uploadedImg="config[field.key]" @uploaded="handleUpload"
                            class="small-image" :tip="field.memo"></image-uploader>
        </el-form-item>
    </div>
</template>

<script>

  import ImageUploader from '@/components/ImageUploader.vue';

  export default {
    name: 'tms-type-small-img',
    props: {
      field: {
        type: [Object, Array],
        required: true
      },
      config: {
        type: Object,
        default() {
          return {}
        }
      }
    },
    data() {
      return {}
    },

    components: {
      ImageUploader
    },

    mounted() {

    },

    methods: {
      handleUpload(src, index) {
        this.$set(this.config, this.field.key, src);
      },
    }
  }

</script>
